export default __webpack_public_path__ + "static/media/pag3.b1c58940.jpg";